<template>
  <div class="top-menu relative flex" :style="notOfficial">
    <div class="flex-1">
      <div class="company ml-20">
        {{companyInfo ? companyInfo.fullName : '机构全称'}}
      </div>
    </div>
    <div class="flex flex-center">
      <div class="mr-10 c-pointer">
        <i class="el-icon-s-promotion fs-18" @click="codeListState = true"></i>
      </div>
      <div  v-if="companyInfo" >
        <el-badge class="message-badge c-pointer mr-15" :value="unreadCount">
          <i class="el-icon-message vr-m" style="font-size:25px" @click="navToMessage"></i>
        </el-badge>
      </div>
      <el-popover
        placement="bottom"
        width="310"
        trigger="click"
        popper-class="popoverClass"
        v-if="companyInfo"
        v-model="searchStatus">
        <div v-if="searchResult.length === 0 && keyWordList.length === 0" class="text-999 ta-c h-50 lh-50">暂时没有相关的内容</div>
        <div v-else>
          <div v-if="searchResult.length === 0 && keyWordList.length !== 0">
            <div class="bd-b lh-40">
              <p class="fs-12 mlr-10 h-30" style="color:#999">你是不是想搜:</p>
              <div 
                v-for="(keyWord, index) in keyWordList" :key="index"
                @click="selectKeyItem(keyWord)"
                class="bd-a h-20 lh-20 ta-c mlr-10 d-ib text-select c-pointer" 
                style="min-width:40px;border-radius:30px;color:#333;padding:0px 8px">
                {{keyWord}}
              </div>
            </div>
            <div class="h-40 lh-40 ta-c text-999">
              暂时没有相关的内容
            </div>
          </div>
          <div v-if="searchResult.length !== 0 && keyWordList.length === 0">
            <div class="bd-b h-40 lh-40 c-pointer search-item text-select" style="padding:0px 10px" v-for="(searchRes, index) in searchResult" :key="index">
              <div class="d-ib flex-1 fs-13" @click="selectArticleItem(searchRes.articleId)" style="width:270px">{{searchRes.articleTitle}}</div>
              <i class="el-icon-link" @click="navToSearchHelp(searchRes.articleId)"></i>
            </div>
          </div>
          <div v-if="searchResult.length !== 0 && keyWordList.length !== 0">
            <div class="bd-b lh-40">
              <p class="fs-12 mlr-10 h-30" style="color:#999">你是不是想搜:</p>
              <div 
                v-for="(keyWord, index) in keyWordList" :key="index" 
                @click="selectKeyItem(keyWord)"
                class="bd-a h-20 lh-20 ta-c mlr-10 d-ib text-select c-pointer" 
                style="min-width:40px;border-radius:30px;color:#333;padding:0px 8px">
                {{keyWord}}
              </div>
            </div>
            <div class="bd-b h-40 lh-40 c-pointer search-item text-select" style="padding:0px 10px" v-for="(searchRes, index) in searchResult" :key="index">
              <div class="d-ib flex-1 fs-13" @click="selectArticleItem(searchRes.articleId)" style="width:270px">{{searchRes.articleTitle}}</div>
              <i class="el-icon-link" @click="navToSearchHelp(searchRes.articleId)"></i>
            </div>
          </div>
        </div>
        <el-button @click="searchFocus" class="searchButton" style="background-color: transparent;" slot="reference">
          <el-input ref="searchInput" @input="inputSearch" v-model="searchValue"  size="mini" style="width:200px">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-button>
      </el-popover>
      <el-popover placement="bottom" trigger="click" v-model="visible">
        <li @click="nav('/setting/personal')">个人设置</li>
        <li @click="logout">退出登录</li>
        <template slot="reference">
          <div class="fs-0 c-pointer">
            <div v-if="userInfo" class="d-ib fs-0">
              <img class="w-30 bd-radius d-ib bg-ddd vr-m" :src="userInfo.avatar">
              <p class="d-ib ml-10 fs-14 vr-m">{{userInfo.nickName}}</p>
              <i class="el-icon-arrow-down fs-14 vr-m ml-15 fw-b"></i>
            </div>
          </div>
        </template>
      </el-popover>
      
    </div>
    <el-dialog :visible.sync="codeListState" title="电税登录验证码" :append-to-body="true">
      <div>
        <el-table height="300" :data="codeList" border>
          <el-table-column label="手机号" prop="mobile"></el-table-column>
          <el-table-column label="验证码" prop="code"></el-table-column>
          <el-table-column label="接收时间" prop="createTime"></el-table-column>
        </el-table>
        <div class="mt-10 ta-c">
          <el-button type="primary" @click="getCode" size="small">刷新</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapMutations,mapActions,mapState} from 'vuex'
import InviteForm from '@/components/Setting/InviteForm'
import {
  Req_GetTaxGovSendCodes
} from '@/request/account'
import {
  Req_SearchArticle,
  Req_SearchKeyword
} from '@/request/helpCenter'
import {Cookie} from '@/util'
var searchTimer = null
export default {
  data() {
    return {
      activeHash:'',
      visible:false,
      searchValue:'',
      searchStatus:false,
      searchResult:[],
      keyWordList:[],
      codeListState: null,
      codeList: [],
      prevCodeGetTime: null,
      timer: null
    };
  },
  created() {
    this.setUnreadCount()
    if(!this.userInfo) this.getUserInfo()
    if(!this.companyInfo) this.getCompanyInfo()
  },
  computed: {
    ...mapState(['userInfo','companyInfo']),
    unreadCount(){
      return this.$store.state.Message.unreadCount
    },
    notOfficial() {
      const style = `background-image: url('https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/caichen/iconImg/notOfficial.png');background-size: 80px;`
      return location.host !== 'www.ccqf.vip' ? style : '' 
    },
  },
  methods: {
    ...mapMutations(['refreshInviteState','removeUserInfo','removeCompanyInfo','clearMessageTimer','removePermission','closeNotify','clearMissionTimer']),
    ...mapActions(['getUserInfo','getCompanyInfo','setSerachArticle','closeHelpBox','setUnreadCount']),
    getCode() {
      const now = new Date()
      if(this.prevCodeGetTime === null || now - this.prevCodeGetTime > 3000) {
        this.prevCodeGetTime = now
        Req_GetTaxGovSendCodes().then(res => {
          this.codeList = res.data
        }).catch(err => this.$catchErr(err))
      } else {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
           this.$message('验证码接收需要时间，请等待3秒后再试')
        },1000)
      }
    },
    selectKeyItem(key){
      this.searchValue = key
      this.inputSearch(key)
    },
    navToSearchHelp(articleId){
      // const { href } = this.$router.resolve({
      //   path:`/helpCenter`,
      //   query:{
      //     articleId
      //   }
      // })
      this.$router.push({
        path:`/helpCenter`,
        query:{
          articleId
        }
      })
      // window.open(href,'_blank')
    },
    selectArticleItem(id){
      this.closeHelpBox()
      this.setSerachArticle(id)
    },
    inputSearch(val){
      clearTimeout(searchTimer);
      if(val === '') {
        this.searchResult = []
        this.keyWordList = []
        return
      }
      const promiseList = [Req_SearchArticle({keyWord:val,pageSize:99999,groupId:this.companyInfo.groupId}),Req_SearchKeyword({keyWord:val,groupId:this.companyInfo.groupId})]
      searchTimer = setTimeout(() => {
        Promise.all(promiseList).then(res => {
          this.searchResult = res[0]
          this.keyWordList = res[1].splice(0,5)
          this.searchStatus = true
        }).catch(err => this.$catchErr(err))
      }, 500);
    },
    searchFocus(){
      this.$refs.searchInput.$el.querySelector('input').focus()
    },
    navToHelp(){

      this.$router.push({path:'/helpCenter'})
    },
    nav(url) {
      this.visible = false
      if(url) this.$router.push(url)
    },
    logout() {
      localStorage.removeItem('token')
      Cookie.set('token','')
      localStorage.removeItem('missionCenterVatType')
      this.removeUserInfo()
      this.removeCompanyInfo()
      this.clearMessageTimer()
      this.closeNotify()
      this.removePermission()
      this.clearMissionTimer()
      this.$router.push('/login')
    },
    navToMessage(){
      if(!location.href.includes('/message/messageCenter')) this.$router.push({path:'/message'})
    }
  },
  watch: {
    codeListState(nv,ov) {
      nv && ov === null && this.getCode()
    }
  },
  components: {
    InviteForm
  }
};
</script>

<style lang="scss" scoped>
.top-menu {
  height: 56px;
  min-width: 1000px;
  border-bottom:1px solid #e6ebf5;
  .company {
    font-size: 16px;
    display: inline-block;
    line-height: 56px;
  }
  .searchButton{
    border:none
  }
  .search-item:hover{
    background: rgba(211, 211, 211,.1);
  }
}
</style>

<style lang="scss">
  .global-header {
    min-width:1200px;
    height: 56px;
    line-height: 56px;
    box-sizing: border-box;
    font-size: 0;
    position: relative;
    border-bottom:1px solid #e6ebf5;
  }
  .lh-56 {
    line-height: 56px;
  }
  .popoverClass{
    padding: 0px 0px !important;
    margin: 0px 0px !important;
    max-height: 300px;
    overflow: auto;
  }
  .message-badge{
    .el-badge__content.is-fixed {
      top: 3px !important;
      right: 11px !important;
      background-color: #c0182f;  
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/TopMenu.vue